import React from "react";
import DealCancelForm from "forms/DealCancelForm";
import PropTypes from "prop-types";

import Modal, { ModalBody, ModalHeader } from "components/Modal";
import Translate from "utils/translate";

const { t } = new Translate("DealCancel");

const DealCancelModal = ({ onClose, onSubmit }) => (
  <Modal onClose={onClose} isOpen>
    <ModalHeader onClose={onClose}>{t("title")}</ModalHeader>
    <ModalBody>
      <DealCancelForm onSubmit={onSubmit} />
    </ModalBody>
  </Modal>
);

DealCancelModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default DealCancelModal;
